module.exports = __webpack_public_path__ + "img/twqr.ce6c8715.png";